import { render, staticRenderFns } from "./cadastrar-precos.vue?vue&type=template&id=92a49de0&scoped=true&"
import script from "./cadastrar-precos.vue?vue&type=script&lang=js&"
export * from "./cadastrar-precos.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-precos.vue?vue&type=style&index=0&id=92a49de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a49de0",
  null
  
)

export default component.exports